import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../../i18n/languages';
import { LANG_USER_CHOICE_KEY } from '../../geo/GeoPricingContext';

export function UsFlag({ size = 19 }) {
  const h = Math.round(size * 0.72);
  return (
    <svg width={size} height={h} viewBox="0 0 640 460" style={{ borderRadius: '2px', display: 'block', flexShrink: 0, boxShadow: '0 0 1px rgba(0,0,0,0.3)' }}>
      <path fill="#bd3d44" d="M0 0h640v460H0z"/>
      <path stroke="#fff" strokeWidth="35.38" d="M0 53h640M0 124h640M0 195h640M0 265h640M0 336h640M0 407h640"/>
      <path fill="#192f5d" d="M0 0h275v248H0z"/>
      <circle cx="35" cy="28" r="9" fill="#fff"/>
      <circle cx="85" cy="28" r="9" fill="#fff"/>
      <circle cx="135" cy="28" r="9" fill="#fff"/>
      <circle cx="185" cy="28" r="9" fill="#fff"/>
      <circle cx="235" cy="28" r="9" fill="#fff"/>
      <circle cx="60" cy="58" r="9" fill="#fff"/>
      <circle cx="110" cy="58" r="9" fill="#fff"/>
      <circle cx="160" cy="58" r="9" fill="#fff"/>
      <circle cx="210" cy="58" r="9" fill="#fff"/>
      <circle cx="35" cy="88" r="9" fill="#fff"/>
      <circle cx="85" cy="88" r="9" fill="#fff"/>
      <circle cx="135" cy="88" r="9" fill="#fff"/>
      <circle cx="185" cy="88" r="9" fill="#fff"/>
      <circle cx="235" cy="88" r="9" fill="#fff"/>
      <circle cx="60" cy="118" r="9" fill="#fff"/>
      <circle cx="110" cy="118" r="9" fill="#fff"/>
      <circle cx="160" cy="118" r="9" fill="#fff"/>
      <circle cx="210" cy="118" r="9" fill="#fff"/>
      <circle cx="35" cy="148" r="9" fill="#fff"/>
      <circle cx="85" cy="148" r="9" fill="#fff"/>
      <circle cx="135" cy="148" r="9" fill="#fff"/>
      <circle cx="185" cy="148" r="9" fill="#fff"/>
      <circle cx="235" cy="148" r="9" fill="#fff"/>
      <circle cx="60" cy="178" r="9" fill="#fff"/>
      <circle cx="110" cy="178" r="9" fill="#fff"/>
      <circle cx="160" cy="178" r="9" fill="#fff"/>
      <circle cx="210" cy="178" r="9" fill="#fff"/>
      <circle cx="35" cy="208" r="9" fill="#fff"/>
      <circle cx="85" cy="208" r="9" fill="#fff"/>
      <circle cx="135" cy="208" r="9" fill="#fff"/>
      <circle cx="185" cy="208" r="9" fill="#fff"/>
      <circle cx="235" cy="208" r="9" fill="#fff"/>
    </svg>
  );
}

export function EsFlag({ size = 19 }) {
  const h = Math.round(size * 0.72);
  return (
    <svg width={size} height={h} viewBox="0 0 640 460" style={{ borderRadius: '2px', display: 'block', flexShrink: 0, boxShadow: '0 0 1px rgba(0,0,0,0.3)' }}>
      <path fill="#c60b1e" d="M0 0h640v460H0z"/>
      <path fill="#ffc400" d="M0 115h640v230H0z"/>
      <circle cx="170" cy="230" r="42" fill="#c60b1e"/>
      <circle cx="170" cy="230" r="28" fill="#ffc400"/>
    </svg>
  );
}

export function FrFlag({ size = 19 }) {
  const h = Math.round(size * 0.72);
  return (
    <svg width={size} height={h} viewBox="0 0 640 460" style={{ borderRadius: '2px', display: 'block', flexShrink: 0, boxShadow: '0 0 1px rgba(0,0,0,0.3)' }}>
      <path fill="#002654" d="M0 0h213.3v460H0z"/>
      <path fill="#fff" d="M213.3 0h213.4v460H213.3z"/>
      <path fill="#ce1126" d="M426.7 0H640v460H426.7z"/>
    </svg>
  );
}

export function DeFlag({ size = 19 }) {
  const h = Math.round(size * 0.72);
  return (
    <svg width={size} height={h} viewBox="0 0 640 460" style={{ borderRadius: '2px', display: 'block', flexShrink: 0, boxShadow: '0 0 1px rgba(0,0,0,0.3)' }}>
      <path fill="#000" d="M0 0h640v153.3H0z"/>
      <path fill="#dd0000" d="M0 153.3h640v153.4H0z"/>
      <path fill="#ffce00" d="M0 306.7h640v153.3H0z"/>
    </svg>
  );
}

export function PhFlag({ size = 19 }) {
  const h = Math.round(size * 0.72);
  return (
    <svg width={size} height={h} viewBox="0 0 640 460" style={{ borderRadius: '2px', display: 'block', flexShrink: 0, boxShadow: '0 0 1px rgba(0,0,0,0.3)' }}>
      <path fill="#0038a8" d="M0 0h640v230H0z"/>
      <path fill="#ce1126" d="M0 230h640v230H0z"/>
      <polygon points="0,0 260,230 0,460" fill="#fff"/>
      <circle cx="85" cy="230" r="28" fill="#fcd116"/>
      <circle cx="30" cy="65" r="9" fill="#fcd116"/>
      <circle cx="30" cy="395" r="9" fill="#fcd116"/>
      <circle cx="195" cy="230" r="9" fill="#fcd116"/>
    </svg>
  );
}

export function JpFlag({ size = 19 }) {
  const h = Math.round(size * 0.72);
  return (
    <svg width={size} height={h} viewBox="0 0 640 460" style={{ borderRadius: '2px', display: 'block', flexShrink: 0, boxShadow: '0 0 1px rgba(0,0,0,0.3)' }}>
      <path fill="#fff" d="M0 0h640v460H0z"/>
      <circle cx="320" cy="230" r="138" fill="#bc002d"/>
    </svg>
  );
}

export function PtFlag({ size = 19 }) {
  const h = Math.round(size * 0.72);
  return (
    <svg width={size} height={h} viewBox="0 0 640 460" style={{ borderRadius: '2px', display: 'block', flexShrink: 0, boxShadow: '0 0 1px rgba(0,0,0,0.3)' }}>
      <path fill="#006600" d="M0 0h256v460H0z"/>
      <path fill="#ff0000" d="M256 0h384v460H256z"/>
      <circle cx="256" cy="230" r="85" fill="#ffcc00"/>
      <circle cx="256" cy="230" r="62" fill="#ffffff"/>
      <circle cx="256" cy="230" r="50" fill="#003399"/>
      <path fill="#ffffff" d="M236 200h40v60h-40z"/>
    </svg>
  );
}

export function ItFlag({ size = 19 }) {
  const h = Math.round(size * 0.72);
  return (
    <svg width={size} height={h} viewBox="0 0 640 460" style={{ borderRadius: '2px', display: 'block', flexShrink: 0, boxShadow: '0 0 1px rgba(0,0,0,0.3)' }}>
      <path fill="#009246" d="M0 0h213.3v460H0z"/>
      <path fill="#fff" d="M213.3 0h213.4v460H213.3z"/>
      <path fill="#ce2b37" d="M426.7 0H640v460H426.7z"/>
    </svg>
  );
}

export function PlFlag({ size = 19 }) {
  const h = Math.round(size * 0.72);
  return (
    <svg width={size} height={h} viewBox="0 0 640 460" style={{ borderRadius: '2px', display: 'block', flexShrink: 0, boxShadow: '0 0 1px rgba(0,0,0,0.3)' }}>
      <path fill="#fff" d="M0 0h640v230H0z"/>
      <path fill="#dc143c" d="M0 230h640v230H0z"/>
    </svg>
  );
}

export function CnFlag({ size = 19 }) {
  const h = Math.round(size * 0.72);
  return (
    <svg width={size} height={h} viewBox="0 0 640 460" style={{ borderRadius: '2px', display: 'block', flexShrink: 0, boxShadow: '0 0 1px rgba(0,0,0,0.3)' }}>
      <path fill="#de2910" d="M0 0h640v460H0z"/>
      <polygon fill="#ffde00" points="105,55 122,96 166,96 130,122 144,163 105,138 66,163 80,122 44,96 88,96"/>
      <polygon fill="#ffde00" points="200,30 206,43 220,43 209,51 213,64 200,56 187,64 191,51 180,43 194,43"/>
      <polygon fill="#ffde00" points="240,77 246,90 260,90 249,98 253,111 240,103 227,111 231,98 220,90 234,90"/>
      <polygon fill="#ffde00" points="240,142 246,155 260,155 249,163 253,176 240,168 227,176 231,163 220,155 234,155"/>
      <polygon fill="#ffde00" points="200,187 206,200 220,200 209,208 213,221 200,213 187,221 191,208 180,200 194,200"/>
    </svg>
  );
}

export function LanguageFlagIcon({ code, size = 19 }) {
  switch (code) {
    case 'en':
      return <UsFlag size={size} />;
    case 'es':
      return <EsFlag size={size} />;
    case 'fr':
      return <FrFlag size={size} />;
    case 'de':
      return <DeFlag size={size} />;
    case 'fil':
    case 'tl':
      return <PhFlag size={size} />;
    case 'ja':
      return <JpFlag size={size} />;
    case 'pt':
      return <PtFlag size={size} />;
    case 'it':
      return <ItFlag size={size} />;
    case 'pl':
      return <PlFlag size={size} />;
    case 'zh':
      return <CnFlag size={size} />;
    default:
      return <UsFlag size={size} />;
  }
}

const colors = {
  teal: 'var(--bv-teal, #00DCBC)',
  tealDark: 'var(--bv-teal-dark, #02B096)',
  blue: 'var(--bv-blue, #18B4EC)',
  navy: '#1a2b4a',
  navyHover: '#16253f',
  ink: 'var(--bv-ink, #1e293b)',
  ink60: 'var(--bv-ink-60, #334155)',
  ink40: 'var(--bv-ink-40, #8D8D8D)',
  border: 'var(--bv-border, #e2e8f0)',
};

export default function LanguageSelector({ isMobile = false, variant = 'default' }) {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const currentLangCode = (i18n.language || 'en').toLowerCase().split('-')[0];
  const normalizedLangCode = currentLangCode === 'tl' ? 'fil' : currentLangCode;

  const currentLang =
    SUPPORTED_LANGUAGES.find((l) => l.code === normalizedLangCode) ||
    SUPPORTED_LANGUAGES[0];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectLanguage = (langCode) => {
    try {
      window.localStorage.setItem(LANG_USER_CHOICE_KEY, '1');
    } catch {
      // storage unavailable — language still changes for this session
    }
    i18n.changeLanguage(langCode);
    handleClose();
  };

  const isFooter = variant === 'footer';

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
      <Button
        onClick={handleClick}
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        size="small"
        sx={{
          backgroundColor: isFooter ? 'rgba(255,255,255,0.12)' : colors.navy,
          borderColor: isFooter ? 'rgba(255,255,255,0.3)' : colors.navy,
          borderWidth: '1px',
          borderStyle: 'solid',
          color: '#fff',
          px: isMobile ? { xs: 1.1, sm: 1.4 } : { xs: 1.2, lg: 1.4, xl: 1.8 },
          py: isMobile ? { xs: 0.55, sm: 0.75 } : { xs: 0.65, lg: 0.75, xl: 0.9 },
          minWidth: 'auto',
          borderRadius: '50px',
          fontFamily: 'Helvetica Neue, sans-serif',
          fontWeight: 600,
          fontSize: isMobile ? '0.66rem' : { xs: '0.66rem', lg: '0.68rem', xl: '0.72rem' },
          textTransform: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          gap: isMobile ? 0.5 : 0.75,
          whiteSpace: 'nowrap',
          flexShrink: 0,
          boxShadow: 'none',
          transition: 'all 180ms ease',
          '&:hover': {
            backgroundColor: isFooter ? 'rgba(255,255,255,0.22)' : colors.navyHover,
            borderColor: isFooter ? 'rgba(255,255,255,0.45)' : colors.navyHover,
            boxShadow: 'none',
          },
        }}
      >
        <LanguageFlagIcon code={currentLang.code} size={isMobile ? 16 : 18} />
        <Typography
          component="span"
          sx={{
            fontWeight: 700,
            fontSize: 'inherit',
            color: '#fff',
            letterSpacing: '0.04em',
            lineHeight: 1,
            fontFamily: 'inherit',
          }}
        >
          {currentLang.shortName}
        </Typography>
        <KeyboardArrowDownIcon
          sx={{
            fontSize: isMobile ? 13 : 14,
            color: '#cbd5e1',
            transition: 'transform 200ms ease',
            transform: open ? 'rotate(180deg)' : 'none',
          }}
        />
      </Button>

      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              width: 140,
              minWidth: 140,
              maxHeight: 380,
              overflowY: 'auto',
              bgcolor: 'var(--bv-card-bg, #ffffff) !important',
              border: '1px solid var(--bv-border, #e2e8f0) !important',
              borderRadius: '14px !important',
              boxShadow: '0 12px 32px rgba(0, 0, 0, 0.25) !important',
              p: 0.6,
              '& .MuiList-root': {
                py: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '2px',
              },
            },
          },
        }}
      >
        {SUPPORTED_LANGUAGES.map((lang) => {
          const isSelected = lang.code === currentLang.code;
          return (
            <MenuItem
              key={lang.code}
              onClick={() => handleSelectLanguage(lang.code)}
              sx={{
                py: 0.8,
                px: 1.2,
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: isSelected
                  ? 'rgba(0, 220, 188, 0.14) !important'
                  : 'transparent',
                color: isSelected ? `${colors.tealDark} !important` : `${colors.ink} !important`,
                transition: 'all 150ms ease',
                '&:hover': {
                  backgroundColor: isSelected
                    ? 'rgba(0, 220, 188, 0.22) !important'
                    : 'var(--bv-surface-2, rgba(255, 255, 255, 0.08)) !important',
                },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
                <LanguageFlagIcon code={lang.code} size={18} />
                <Typography
                  component="span"
                  sx={{
                    fontFamily: 'Helvetica Neue, sans-serif',
                    fontSize: '0.78rem',
                    fontWeight: isSelected ? 700 : 600,
                    color: isSelected ? 'var(--bv-teal, #00DCBC)' : 'var(--bv-ink, #1e293b)',
                    letterSpacing: '0.04em',
                  }}
                >
                  {lang.shortName}
                </Typography>
              </Box>

              {isSelected && (
                <CheckIcon sx={{ fontSize: 16, color: 'var(--bv-teal, #00DCBC)' }} />
              )}
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
}
